import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { EdicaoLayoutHibrido } from "src/components/projetos/edicao/layouts/EdicaoLayoutHibrido";
import { ProjetosFormInicialHibrido } from "src/components/projetos/hibrido/FormInicialHibrido";

const PAGE_TITLE = 'Clonar projeto dimensionado híbrido'

const ProjetosFormInicialDimensionadoHibridoClonar = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])
  
  return (
    <EdicaoLayoutHibrido clonarProjeto>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicialHibrido />
          </div>
        </div>
      </div>
    </EdicaoLayoutHibrido>
  );
};

export { ProjetosFormInicialDimensionadoHibridoClonar };
